const statusColorBoolean = status => (status ? 'light-success' : 'light-danger')
const statusActiveBoolean = status => (status ? 'Active' : 'Suspended')

export {
  statusColorBoolean,
  statusActiveBoolean,
}

export const _ = undefined
